module.exports = __webpack_public_path__ + "img/20.8f5c64ca.png";